import gql from "graphql-tag";

export const getComptes = gql`
  query getComptes($utilisateurId: Int!) {
    getComptes(utilisateurId: $utilisateurId) {
      id
      banque
      label
      name
      balance
      identifiant
      sheetsActive
      active
      retrievalDate
      syncing
      syncStatus
      bridgeRenewUrl
      type
    }
  }
`;

export const getGoogleLink = gql`
  query getGoogleLink($utilisateurId: Int!) {
    getGoogleLink(utilisateurId: $utilisateurId) {
      url
    }
  }
`;

export const getGoogleToken = gql`
  query getGoogleToken($code: String!, $utilisateurId: Int!) {
    getGoogleToken(code: $code, utilisateurId: $utilisateurId) {
      token
    }
  }
`;

export const getGoogleSheetsStatus = gql`
  query getGoogleSheetsStatus($utilisateurId: Int!) {
    getGoogleSheetsStatus(utilisateurId: $utilisateurId) {
      type
      message
      details
    }
  }
`;
